import { useMediaQuery } from "react-responsive";

export const useQuery = () => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const isDesktop = useMediaQuery({ minWidth: 992 });
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 991 });
  const isDefault = useMediaQuery({ minWidth: 768 });

  return {
    isMobile,
    isDesktop,
    isTablet,
    isDefault,
  };
};
